import React from 'react';
import Header from '../Header';
import Pasos from '../../Online/Pasos';
import { Link } from "react-router-dom";
import useResizeEventIframe from '../../Utils/Iframe';
import headerCupra from '../../App/imgs/cupra/cupra-header-compra.png';
import headerCupraMd from '../../App/imgs/cupra/cupra-header-compra-md.png';
import headerCupraSm from '../../App/imgs/cupra/cupra-header-compra-sm.png';
import ProgressStepBarCupra from '../../componentes/cupra/controls/ProgressStepBarCupra';
import LinkButton from '../../componentes/cupra/controls/LinkButton';
import ButtonPrimary from '../../componentes/cupra/controls/ButtonPrimary';
import './compra.scss';

class Compra extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }

    render() {
        let SetResizeIframe = () => { useResizeEventIframe(this.ref); return null };
        return <div className={"container__font--" + this.props.marca} ref={this.ref}>
            {this.props.marca === 'audi' && <SetResizeIframe />}

            {
                this.props.marca !== "cupra" ?

                    <>
                        <Header marca={this.props.marca} nfz={this.props.location.pathname.startsWith("/es/app/sigue-tu-volkswagen/vw/")} />
                        <div className="container">
                            <div className="col col-md-8 offset-md-2 pt-5 pb-5">
                                {
                                    this.props.marca === "audi" ? (
                                        <h2>Sigue tu Audi</h2>
                                    ) : (this.props.marca === "vw" ? (
                                        <h1 className="container__titulo--vw  font__title--ligth">Sigue tu<br /> <span className="font__title--bold">Volkswagen</span></h1>
                                    ) : (
                                        this.props.marca === "seat" ? (
                                            <h2>Sigue tu SEAT</h2>
                                        ) : ""
                                    )
                                    )
                                }
                            </div>
                        </div>
                        <Pasos marca={this.props.marca} servicioFirebase={this.props.servicioFirebase} pasos={this.props.location.state} offline={this.props.offline} />
                        <div className="container">
                            <div className="col col-md-8 offset-md-2 mb-3 text-left">
                                <a className={"guias__aviso--" + this.props.marca} href={this.props.location.state.concesionaria[0].terminosCondiciones} target="_blank" rel="noopener noreferrer">
                                    Aviso de privacidad
                                    {
                                        this.props.marca === "seat" ? (
                                            <svg width="8px" height="14px" viewBox="0 0 8 14" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                                                <g id="" stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
                                                    <g id="color" transform="translate(-164.000000, -22.000000)" fill="#0f0f0f">
                                                        <g id="" transform="translate(24.000000, 16.000000)">
                                                            <polygon id="" transform="translate(144.000000, 12.500000) rotate(-90.000000) translate(-144.000000, -12.500000) " points="148.971417 8.5 144.001083 13.4435897 139.029667 8.5 139.0275 8.5 137.5 10.0211876 144.001083 16.5 150.5 10.0211876 148.973583 8.5"></polygon>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        ) : (this.props.marca === "audi" ? (
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" >
                                                <path stroke="currentColor" strokeWidth="1px" fill="none" d="M1.5,1l5.485,5.504l-5.48,5.496"></path>
                                            </svg>
                                        ) : "")
                                    }
                                </a>
                            </div>
                        </div>
                        <div className={"container"}>
                            <div className="col pt-5 pb-5 col-md-4 offset-md-4">
                                <Link to={this.props.marca !== "vw" && this.props.location.pathname.startsWith("/es/app/sigue-tu-volkswagen/vw/") !== true ? "/" + this.props.marca + "/consultar" : (this.props.marca === "vw" && this.props.location.pathname.startsWith("/es/app/sigue-tu-volkswagen/vw/") !== true ? "/app/sigue-tu-volkswagen/vw/consultar" : (this.props.marca === "vw" && this.props.location.pathname.startsWith("/es/app/sigue-tu-volkswagen/vw/") === true ? "/es/app/sigue-tu-volkswagen/vw/consultar.html" : ""))} className={"w-100 form__button--" + this.props.marca + "-ghost form__button--" + this.props.marca} name="consultar">
                                    Introduce una nueva GUÍA
                                </Link>
                            </div>
                        </div>
                    </>


                    :

                    <div className='fondo--offline'>
                        <div className={"conteiner-header-cupra" + (this.props.marca === "cupra" ? "-visible fondo--offline" : "")}>
                            <img className='d-none d-lg-block compra-img-header-cupra' src={headerCupra} alt="header_kmi_cupra" />
                            <img className='d-none d-md-block d-lg-none compra-img-header-cupra' src={headerCupraMd} alt="header_kmi_cupra" />
                            <img className='d-block d-md-none compra-img-header-cupra' src={headerCupraSm} alt="header_kmi_cupra" />
                            <div className='img-text-cupra' />
                        </div>

                        <label className={'compra-title'}>SIGUE TU CUPRA</label>
                        <div className='guiaPanel'>
                            <label className={'compra-subtitle guia'}>Guía:</label>
                            <label className={'guianumber'}>{this.props.location.state.estatusActual.idCompra}</label>
                        </div>

                        <div className='compra-progressPanel'>
                            <div className='compra-progresssubPanel'>
                                <div className="d-flex flex-column">
                                    <div className="compra-subtitle">Tu proceso al día de hoy:</div>
                                    <div className="statusActual">{this.props.location.state.estatusActual.nombreEstatus}</div>
                                    <div className="historial-subtitle">Historial de seguimiento.</div>
                                </div>
                                <ProgressStepBarCupra pasos={this.props.location.state} />
                            </div>

                            <div className='compra-aviso'>
                                <LinkButton title={"Aviso de privacidad"} ruta={"https://www.cupraoficial.mx/hibridos-conectables/ap-concesionarios"} />
                            </div>

                            <div className='compra-btn'>
                                <Link to={this.props.marca !== "vw" && this.props.location.pathname.startsWith("/es/app/sigue-tu-volkswagen/vw/") !== true ? "/" + this.props.marca + "/consultar" : (this.props.marca === "vw" && this.props.location.pathname.startsWith("/es/app/sigue-tu-volkswagen/vw/") !== true ? "/app/sigue-tu-volkswagen/vw/consultar" : (this.props.marca === "vw" && this.props.location.pathname.startsWith("/es/app/sigue-tu-volkswagen/vw/") === true ? "/es/app/sigue-tu-volkswagen/vw/consultar.html" : ""))} className={"w-100 form__button--" + this.props.marca + "-ghost form__button--" + this.props.marca} name="consultar">
                                    <ButtonPrimary textButton={"Introduce una nueva guía"} />
                                </Link>
                            </div>
                        </div>
                    </div>
            }
        </div>
    }
}

export default Compra;